import { InjectionToken } from '@angular/core';

export const PAYMENT_URL = new InjectionToken<string>('PAYMENT_URL');
